var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "expense-list" },
    _vm._l(_vm.expenses, function(expense) {
      return _c("expense-list-entry", {
        key: expense.id,
        attrs: { expense: expense },
        on: {
          "deleted-expense": function(expenseId) {
            return _vm.$emit("deleted-expense", expenseId)
          }
        }
      })
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }